module.exports = __webpack_public_path__ + "static/media/roses.8eac0d41.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/roses.png
// module id = 13
// module chunks = 0